import {
  AtRiskIcon as AtRiskIconOld,
  UnexpectedIcon as UnexpectedIconOld,
  ExpectedIcon as ExpectedIconOld,
} from "../../../Styles/Icons";

export const RiskLevelIcon = {
  EXPECTED: ExpectedIconOld,
  UNEXPECTED: UnexpectedIconOld,
  AT_RISK: AtRiskIconOld,
};
